/* eslint-disable import/no-unused-modules */
import type { UserPersonas } from '@carboncopyco/types/desktop';

export const getPersonasIdDefaultOnTop = (personas: UserPersonas) => {
  const otherPersonas = Object.keys(personas.personas).filter(
    (personaId) => personaId !== personas.defaultId
  );
  return [personas.defaultId, ...otherPersonas];
};
